module.exports = {"140406001":"潞华街道","140406002":"成家川街道","140406003":"翟店街道","140406100":"店上镇","140406101":"微子镇","140406102":"辛安泉镇","140406104":"史回镇","140406201":"黄牛蹄乡","140406400":"潞城经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140406.json
// module id = 381
// module chunks = 0